import {createEntityAdapter, EntityState} from '@ngrx/entity';
import { DoctorActions, DoctorActionTypes } from '../../../actions/mdqx/doctor/doctor.actions';
import { DoctorEntity } from '../../../../entities/mdqx/doctor/doctor.entity';

export interface DoctorState extends EntityState<DoctorEntity> {
    fetched: boolean;
}

export const DOCTOR_KEY = 'doctor';

const adapter = createEntityAdapter<DoctorEntity>({
    selectId: doctor => doctor.Id
});

const initialState = adapter.getInitialState({
    fetched: false
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function doctorReducer(state = initialState, action: DoctorActions): DoctorState {
    switch (action.type) {
        case DoctorActionTypes.GetDoctorsResponse: {
            return adapter.setAll(action.Payload, {...state, fetched: true});
        }

        case DoctorActionTypes.PostDoctorResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case DoctorActionTypes.PatchDoctorResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case DoctorActionTypes.DeleteDoctorResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const {selectAll} = adapter.getSelectors();

export const selectAllDoctors = selectAll;

export const selectDoctorsFetched = (state: DoctorState) => state.fetched;
